/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'APP_THEME/business_page/eddm_page/index.less';

import 'jquery-ui/jquery-ui';
import 'selectboxit/src/javascripts/jquery.selectBoxIt.min';
import 'bootstrap';

$(function() {
    $('.filter-datepicker').datepicker({});
    $('#eddm-services-form select').selectBoxIt({ autoWidth: false });
    $('[data-toggle="popover"]').popover();
    $('.js-non-profit-toggle').on('click', function() {
        $('.is-non-profit').toggle();
    });

    $('.file-input-remove input').on('change', function() {
        if (this.files.length > 0) {
            $(this)
                .closest('.file-input-remove')
                .find('.remove')
                .show();
        }
    });
    $('.file-input-remove .remove').on('click', function() {
        var $elem = $(this);
        if (confirm($elem.data('message'))) {
            $elem
                .parent()
                .find('input[type="file"]')
                .val('');
            $(this).hide();
        }
    });
});
